import React from 'react';

const SearchIcon = () => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0057 8.83335H9.37336L9.14923 8.61723C9.93368 7.70471 10.4059 6.52003 10.4059 5.23129C10.4059 2.35765 8.07662 0.0283203 5.20297 0.0283203C2.32933 0.0283203 0 2.35765 0 5.23129C0 8.10494 2.32933 10.4343 5.20297 10.4343C6.49171 10.4343 7.67639 9.962 8.58891 9.17755L8.80503 9.40168V10.034L12.8073 14.0283L14 12.8356L10.0057 8.83335ZM5.20297 8.83335C3.20983 8.83335 1.60091 7.22443 1.60091 5.23129C1.60091 3.23815 3.20983 1.62924 5.20297 1.62924C7.19611 1.62924 8.80503 3.23815 8.80503 5.23129C8.80503 7.22443 7.19611 8.83335 5.20297 8.83335Z"
      fill="#959595"
    />
  </svg>
);

export default SearchIcon;
